import { render, staticRenderFns } from "./DFloater.vue?vue&type=template&id=2f24bfd6&"
import script from "./DFloater.vue?vue&type=script&lang=ts&"
export * from "./DFloater.vue?vue&type=script&lang=ts&"
import style0 from "./DFloater.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports